import produce from 'immer';
import { CustomerDepartmentResponse, DepartmentListItemResponse, UserItemResponse } from '../../../api';
import { baseCustomerDepartmentActions } from '../actions';

export interface CustomerDepartmentState {
  department: {
    data: CustomerDepartmentResponse | undefined;
    ok: boolean | undefined;
  };
  customerUsers: {
    data: UserItemResponse[];
    ok: boolean | undefined;
  };
  customerActiveUsers: {
    data: UserItemResponse[];
    ok: boolean | undefined;
  };
  crud: {
    data: DepartmentListItemResponse | undefined;
    ok: boolean | undefined;
  };
}

export const INITIAL_CUSTOMER_DEPARTMENT_STATE: CustomerDepartmentState = {
  department: {
    data: undefined,
    ok: undefined,
  },
  customerUsers: {
    data: [],
    ok: undefined,
  },
  customerActiveUsers: {
    data: [],
    ok: undefined,
  },
  crud: {
    data: undefined,
    ok: undefined,
  },
};

export function BaseCustomerDepartmentReducer(
  state: CustomerDepartmentState = INITIAL_CUSTOMER_DEPARTMENT_STATE,
  action: any
): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      // Customer department
      case baseCustomerDepartmentActions.loadCustomerDepartment.type:
        draftState.department.ok = undefined;
        return;

      case baseCustomerDepartmentActions.setCustomerDepartment.type:
        draftState.department.data = action.payload;
        return;

      case baseCustomerDepartmentActions.successCustomerDepartment.type:
        draftState.department.ok = true;
        return;

      case baseCustomerDepartmentActions.errorCustomerDepartment.type:
        draftState.department.ok = false;
        return;

      case baseCustomerDepartmentActions.resetCustomerDepartment.type:
        draftState.department = INITIAL_CUSTOMER_DEPARTMENT_STATE.department;
        return;

      // Customer users
      case baseCustomerDepartmentActions.loadCustomerUsers.type:
        draftState.customerUsers.ok = undefined;
        return;

      case baseCustomerDepartmentActions.setCustomerUsers.type:
        draftState.customerUsers.data = action.payload;
        return;

      case baseCustomerDepartmentActions.successCustomerUsers.type:
        draftState.customerUsers.ok = true;
        return;

      case baseCustomerDepartmentActions.errorCustomerUsers.type:
        draftState.customerUsers.ok = false;
        return;

      // Customer active users
      case baseCustomerDepartmentActions.loadCustomerActiveUserList.type:
        draftState.customerActiveUsers.ok = undefined;
        return;

      case baseCustomerDepartmentActions.setCustomerActiveUserList.type:
        draftState.customerActiveUsers.data = action.payload;
        return;

      case baseCustomerDepartmentActions.successCustomerActiveUserList.type:
        draftState.customerActiveUsers.ok = true;
        return;

      case baseCustomerDepartmentActions.errorCustomerActiveUserList.type:
        draftState.customerActiveUsers.ok = false;
        return;

      // Department crud
      case baseCustomerDepartmentActions.createDepartmentCrud.type:
        draftState.crud.ok = undefined;
        return;

      case baseCustomerDepartmentActions.setDepartmentCrud.type:
        draftState.crud.data = action.payload;
        return;

      case baseCustomerDepartmentActions.successDepartmentCrud.type:
        draftState.crud.ok = true;
        return;

      case baseCustomerDepartmentActions.errorDepartmentCrud.type:
        draftState.crud.ok = false;
        return;
    }
  });
}
